// <s-variant-media> brings the selected color's photo to the front of the product gallery.
// It listens for the variant picker's bubbling option `change` events and reads a
// variant-id → media-id map from its child script[data-variant-media] (written by Liquid).
class VariantMedia extends HTMLElement {
  #controller;
  #map = {};

  connectedCallback() {
    this.#controller = new AbortController();
    try {
      this.#map = JSON.parse(this.querySelector('script[data-variant-media]')?.textContent || '{}');
    } catch {
      this.#map = {};
    }

    this.addEventListener('change', (event) => {
      const input = event.target;
      const variantId = input?.dataset?.variantId || input?.selectedOptions?.[0]?.dataset?.variantId;
      if (variantId) this.#show(variantId, true);
    }, { signal: this.#controller.signal });

    // Open on the selected color's photo: deep links (?variant=) first, else the default variant.
    const initialVariant = new URL(window.location.href).searchParams.get('variant') || this.dataset.selectedVariant;
    if (initialVariant) this.#show(initialVariant, false);
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #show(variantId, animate) {
    const mediaId = this.#map[variantId];
    const gallery = this.querySelector('[data-product-gallery]');
    if (!mediaId || !gallery) return;

    const item = gallery.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
    if (!item) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const smooth = animate && !reduceMotion;
    const moveToFront = () => gallery.prepend(item);

    if (gallery.firstElementChild !== item) {
      if (smooth && document.startViewTransition) {
        document.startViewTransition(moveToFront);
      } else {
        moveToFront();
      }
    }
    gallery.scrollTo({ left: 0, behavior: smooth ? 'smooth' : 'auto' });
  }
}

if (!customElements.get('s-variant-media')) {
  customElements.define('s-variant-media', VariantMedia);
}
